// js/custom-element/section/tabbed-collection/tabbed-collection.js
(function () {
  var TabbedCollection = class extends CustomHTMLElement {
    connectedCallback() {
      this.delegate.on('pagination:page-changed', this._onPageChanged.bind(this));
      this.delegate.on('tabs-nav:changed', this._onTabChanged.bind(this));
    }

    _onPageChanged(event) {
      const activePanelId = this._getActivePanelId();
      this._rerender(event.detail.url, activePanelId, true);
    }

    _onTabChanged(event) {
      const url = new URL(window.location.href);

      if (!url.searchParams.has('page')) {
        return;
      }

      url.searchParams.delete('page');
      this._rerender(url.toString(), event.detail.button.getAttribute('aria-controls'), false);
    }

    _getActivePanelId() {
      const activeTab = this.querySelector('.tabbed-collection__tab[aria-expanded="true"]');
      return activeTab ? activeTab.getAttribute('aria-controls') : null;
    }

    async _rerender(url, activePanelId, scroll) {
      this._abort();
      this.showLoadingBar();
      history.replaceState({}, '', url);

      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.getAttribute('section-id'));

      try {
        this.abortController = new AbortController();

        const response = await fetch(fetchUrl.toString(), { signal: this.abortController.signal });
        const html = await response.text();
        const fakeDiv = document.createElement('div');
        fakeDiv.innerHTML = html;

        const newMain = fakeDiv.querySelector('.tabbed-collection__main');
        const currentMain = this.querySelector('.tabbed-collection__main');

        if (newMain && currentMain) {
          currentMain.innerHTML = newMain.innerHTML;
        }

        if (activePanelId) {
          Array.from(this.querySelectorAll('.tabbed-collection__panel')).forEach((panel) => {
            panel.hidden = panel.id !== activePanelId;
          });
        }

        if (scroll) {
          requestAnimationFrame(() => {
            this.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
        }

        this.hideLoadingBar();
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        this.hideLoadingBar();
      }
    }

    _abort() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  };

  window.customElements.define('tabbed-collection', TabbedCollection);
})();
